function getData(product) {
    n = 0;
    $.when($.ajax({
        url: "https://ready-made.sarahdrakedesign.com/api/getPricingData",
        method: "GET",
        dataType: "jsonp"
    })).done(function(t) {
        data = t, setTimeout(function() {
            renderData(product, data)
        }, n)
    })
}

function renderData(product, data) {
        $.getJSON("/products/" + product + ".js", function (t) {
          var e = "",
            i = "";
          (t.hasArtwork = !1),
            (t.hasFoil = !1),
            (t.hasFlat = !1),
            (t.hasLetterpress = !1),
            (t.arArtworkPresets = []);
          var o = 0;
          for (v in t.tags) {
            var n = t.tags[v];
            if (0 <= n.indexOf("color-def-"))
              e = n.replace("color-def-", "").replace(/\-hex\-.*/g, "");
            if (
              0 <= n.indexOf("printing-") &&
              -1 == n.indexOf("printing-watercolor")
            ) {
              var s = n.replace("printing-", ""),
                a = s[0].toUpperCase() + s.slice(1);
              (i += 0 == o ? a : ", " + a), 0 == o && n, o++;
            }
            if (
              (0 <= n.indexOf("printing-flat") && (t.hasFlat = !0),
              0 <= n.indexOf("printing-foil") && (t.hasFoil = !0),
              0 <= n.indexOf("printing-letterpress") && (t.hasLetterpress = !0),
              0 <= n.indexOf("has-artwork") && (t.hasArtwork = !0),
              0 <= n.indexOf("artwork-preset-"))
            ) {
              var r = n.replace("artwork-preset-", "");
              t.arArtworkPresets.push(r);
            }
          }
          (t.printingOpts = i.replace(/,(?=[^,]*$)/, " or")),
          document.getElementById("printingOpts").innerText = t.printingOpts;

          var l = [],
            c = [];
          for (v in t.images) {
            -1 == (h = t.images[v]).indexOf(e + "-full.png") &&
              -1 == h.indexOf("lifestyle_") &&
              l.push(v);
          }
          for (var d = l.length; d--; ) t.images.splice(l[d], 1);
          for (v in (t.featured_image.replace("-full.png", "-zoom.jpg"),
          t.images)) {
            var h,
              p = (h = t.images[v]).replace(".png", "_small.png"),
              u = h.replace("-full.png", "-zoom.jpg");
            -1 < h.indexOf("lifestyle_") &&
              (p = h.replace(".jpg", "_small.jpg"));
            var f = {
              normal: h,
              small: p,
              zoomed: u,
            };
            c.push(f);
          }
          Handlebars.registerHelper("renderHtml", function (t) {
            return new Handlebars.SafeString(t);
          }),
            ($isDayOf = document.body.classList.contains("day-of-pricing")),
            (t.images = c),
            (t.tableTitle = $isDayOf ? "DAY OF" : "FULL SUITE"),
            (t.arQtys = data.arQtys),
            (t.arFlat = $isDayOf ? data.arFlat_dayOf : data.arFlat),
            (t.arFlatAddons = data.arFlatAddons),
            (t.arFlatTotal = $isDayOf ? data.arFoilDayOfTotal : data.arFlatTotal),
            (t.arLetterpress = $isDayOf
              ? data.arLetterpress_dayOf
              : data.arLetterpress),
            (t.arLetterpressAddons = data.arLetterpressAddons),
            (t.arLetterpressTotal = $isDayOf
              ? data.arLetterpressDayOfTotal
              : data.arLetterpressTotal),
            (t.arLetterpress2 = $isDayOf
              ? data.arLetterpress2_dayOf
              : data.arLetterpress2),
            (t.arLetterpress2Addons = data.arLetterpress2Addons),
            (t.arLetterpress2Total = $isDayOf
              ? data.arLetterpress2DayOfTotal
              : data.arLetterpress2Total),
            (t.arFoil = $isDayOf ? data.arFoil_dayOf : data.arFoil),
            (t.arFoilAddons = data.arFoilAddons),
            (t.arFoilTotal = $isDayOf ? data.arFoilDayOfTotal : data.arFoilTotal);
            var m = {
              item: t,
            },
            w = $("#QVPopUp").html(),
            y = Handlebars.compile(w);
          window.history.pushState("handle-" + product, "Handle", "?handle=" + product),
            $("#price_min").append(m.item.price_min / 100),
            $(".pop-up-cnt .inner").html("").append(y(m)),
            768 < $(window).width() &&
              $("#mainImage").elevateZoom({
                scrollZoom: !0,
                borderSize: 1,
              });
        });
}


const handle = document.querySelector('[itemprop=name]').getAttribute("id");
let data = {};
getData(handle);